// import React from 'react';
// import { BrowserRouter as Router } from 'react-router-dom';
// import UserRoutes from './routes/UserRoutes';
// import AdminRoutes from './routes/AdminRoutes';

// function App() {
//   return (
//     <Router>
//         <UserRoutes />
//     </Router>
//   );
// }

// export default App;


// App.tsx or your main routing file
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import UserRoutes from './routes/UserRoutes';
import AdminRoutes from './routes/AdminRoutes';

function App() {
  return (
    <Router>
      <Routes>
        {/* User Routes */}
        <Route path="/*" element={<UserRoutes />} />
        
        {/* Admin Routes */}
        <Route path="/admin/*" element={<AdminRoutes />} />
      </Routes>
    </Router>
  );
}

export default App;